import { Modal } from '../modal/Modal';

import styled from 'styled-components';
import { Button } from '../Button';
import { useState } from 'react';
import { InputComponent } from '../form/InputComponent';

export interface ModalAddUserProps {
  show?: boolean;
  onClose: () => void;
  addUser: (user: any) => void;
  isEmailAlreadyUsed: (email: string) => boolean;
}

export const ModalAddUser = ({ show, onClose, addUser, isEmailAlreadyUsed }: ModalAddUserProps) => {
  const [newUser, setNewUser] = useState({ firstName: '', lastName: '', email: '' });

  const handleNewUserInfosChange = e => {
    setNewUser({
      ...newUser,
      [e.target.name]: e.target.value.trim(),
    });
  };

  return (
    <>
      <Modal onClose={onClose} show={show} title={'Ajouter un administrateur'} size={{ height: '50%' }}>
        <WarningContainer>
          Accorder le rôle d'administrateur signifie un accès illimité à toutes les données et informations dans l'application.
        </WarningContainer>

        <BasicModalContainer>
          <InputContainer>
            <InputComponent
              focus={true}
              placeholder={'Pesquet'}
              sharable={false}
              label={'Nom :'}
              type={'text'}
              onChange={handleNewUserInfosChange}
              name={'lastName'}
              value={newUser?.lastName}
            />
            <InputComponent
              focus={true}
              placeholder={'Thomas'}
              sharable={false}
              label={'Prénom :'}
              type={'text'}
              onChange={handleNewUserInfosChange}
              name={'firstName'}
              value={newUser?.firstName}
            />
          </InputContainer>
          <InputComponent
            focus={true}
            placeholder={'thomas.pesquet@gmail.com'}
            sharable={false}
            label={'Email :'}
            type={'text'}
            onChange={handleNewUserInfosChange}
            name={'email'}
            error={isEmailAlreadyUsed(newUser?.email) && 'Ce mail est déjà utilisé'}
            value={newUser?.email}
          />
          <ButtonContainer>
            <Button
              disabled={isEmailAlreadyUsed(newUser.email) || !newUser.firstName || !newUser.lastName || !newUser.email}
              onClick={() => addUser(newUser)}
              label={'Créer'}
            />
            <Button type={'light'} onClick={onClose} label={'Annuler'} />
          </ButtonContainer>
        </BasicModalContainer>
      </Modal>
    </>
  );
};

const BasicModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  column-gap: 20px;
  align-items: center;
  row-gap: 26px;
`;

const InputContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;
  column-gap: 10px;
`;

const ButtonContainer = styled.div`
  display: flex;
  column-gap: 20px;
  align-items: center;
`;

const WarningContainer = styled.div`
  font-size: 1.3em;
  padding-top: 35px;
  padding-bottom: 20px;
  color: #f49d1d;
  font-family: 'Baloo 2';
  font-weight: 700;
  padding: 0;
`;
